import React from 'react'
import SearchableSelect from '../../../../../../generic/ui/SearchableSelect/SearchableSelect'
import FilterIcon from '../../../../../../generic/icons/IconLib/FilterIcon'
import { MiunTab } from '../../services/hooks/useCreateMiun'

interface TabOption {
    id: MiunTab
    label: string
}

const OPTIONS: TabOption[] = [
    { id: 'למיון', label: 'למיון' },
    { id: 'במיון', label: 'במיון' },
]

interface Props {
    value: MiunTab
    onChange: (next: MiunTab) => void
    className?: string
}

const MiunTabSelector: React.FC<Props> = ({ value, onChange, className }) => {
    const selected = OPTIONS.find((o) => o.id === value) ?? OPTIONS[0]
    return (
        <SearchableSelect<TabOption>
            items={OPTIONS}
            value={selected}
            onSelect={(opt) => opt && onChange(opt.id)}
            getKey={(opt) => opt.id}
            getLabel={(opt) => opt.label}
            leadingIcon={<FilterIcon />}
            className={className}
        />
    )
}

export default MiunTabSelector
